export default __webpack_public_path__ + "locales/az/PrivacyPage.json?hash=36572554ad69d865229b117543e43350";